var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15826_21037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2381 6.19049H19.2857V5.23811C19.2857 2.87508 17.3632 0.952383 14.9999 0.952383C12.6367 0.952383 10.7142 2.87502 10.7142 5.23811V6.19049H9.76184V5.23811C9.76184 2.34979 12.1116 0 14.9999 0C17.8883 0 20.2381 2.34979 20.2381 5.23811V6.19049Z",
    fill: "#785550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19043 16.1905V28.0952C1.19043 29.1472 2.0432 30 3.0952 30H26.9047C27.9567 30 28.8095 29.1472 28.8095 28.0952V16.1905H1.19043Z",
    fill: "#694B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90473 21.4286H23.0952C25.3715 21.4286 27.4121 20.4199 28.8095 18.8322V16.1905H1.19043V28.0952C1.19043 29.1472 2.0432 30 3.0952 30H26.9047C27.9567 30 28.8095 29.1472 28.8095 28.0952H8.3333C6.22937 28.0952 4.52377 26.3896 4.52377 24.2857V22.2559C4.52377 21.6681 5.05047 21.22 5.62967 21.3196C6.0441 21.391 6.46996 21.4286 6.90473 21.4286Z",
    fill: "#5A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0952 20.4762H6.90472C3.2228 20.4762 0.238037 17.4914 0.238037 13.8095V8.09521C0.238037 7.56921 0.664424 7.14282 1.19042 7.14282H28.8095C29.3355 7.14282 29.7618 7.56921 29.7618 8.09521V13.8095C29.7618 17.4914 26.7771 20.4762 23.0952 20.4762Z",
    fill: "#785550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7142 5.2381H9.76184C9.49881 5.2381 9.28564 5.45126 9.28564 5.71429V7.14286H11.1904V5.71429C11.1904 5.45126 10.9772 5.2381 10.7142 5.2381Z",
    fill: "#5A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.238 5.2381H19.2856C19.0226 5.2381 18.8094 5.45126 18.8094 5.71429V7.14286H20.7142V5.71429C20.7142 5.45126 20.501 5.2381 20.238 5.2381Z",
    fill: "#5A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0476 10.9524H5.47617C3.89824 10.9524 2.61902 9.67325 2.61902 8.09527V7.14288H26.9047V8.09527C26.9048 9.6732 25.6256 10.9524 24.0476 10.9524Z",
    fill: "#8C5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 22.8571H20.9524C20.6894 22.8571 20.4762 22.6439 20.4762 22.3809V17.619C20.4762 17.356 20.6894 17.1428 20.9524 17.1428H21.4286C21.6915 17.1428 21.9048 17.356 21.9048 17.619V22.3809C21.9048 22.644 21.6916 22.8571 21.4286 22.8571Z",
    fill: "#5A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1429 21.9047H20.2381C19.7122 21.9047 19.2858 21.4784 19.2858 20.9524V20.2381H23.0953V20.9524C23.0953 21.4784 22.6689 21.9047 22.1429 21.9047Z",
    fill: "#E1A546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.381 20.9524H20C19.6055 20.9524 19.2858 20.6325 19.2858 20.2381C19.2858 19.8436 19.6056 19.5238 20 19.5238H22.381C22.7755 19.5238 23.0952 19.8436 23.0952 20.2381C23.0953 20.6325 22.7755 20.9524 22.381 20.9524Z",
    fill: "#FFC850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0476 22.8571H8.57141C8.30844 22.8571 8.09521 22.6439 8.09521 22.3809V17.619C8.09521 17.356 8.30844 17.1428 8.57141 17.1428H9.0476C9.31057 17.1428 9.52379 17.356 9.52379 17.619V22.3809C9.52379 22.644 9.31057 22.8571 9.0476 22.8571Z",
    fill: "#5A4146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76193 21.9047H7.85717C7.33117 21.9047 6.90479 21.4784 6.90479 20.9524V20.2381H10.7143V20.9524C10.7143 21.4784 10.288 21.9047 9.76193 21.9047Z",
    fill: "#E1A546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20.9524H7.61917C7.22465 20.9524 6.90491 20.6325 6.90491 20.2381C6.90491 19.8436 7.22471 19.5238 7.61917 19.5238H10.0001C10.3946 19.5238 10.7144 19.8436 10.7144 20.2381C10.7143 20.6325 10.3946 20.9524 10.0001 20.9524Z",
    fill: "#FFC850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15826_21037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.134b6b05ed06a6c574ccd5995b9a73a1.svg";
export { ForwardRef as ReactComponent };